import { Button, Modal } from 'react-bootstrap';
import * as Excel from "exceljs/dist/exceljs.min.js";
import IconImage from 'src/decklist/smnIcon.js';

export default function PrintConfirmationModal(props) {

  const exportToExcel = async () => {
    // Initialize workbook and worksheet
    const workbook = new Excel.Workbook();
    const worksheet =  workbook.addWorksheet('Deck List', {
      pageSetup: {
        paperSize: 9, 
        orientation:'portrait', 
        fitToPage: false, 
        printArea: 'A1:F53',
        margins: {
          left: 0.25, right: 0.25,
          top: 0.25, bottom: 0.25,
          header: 0, footer: 0,
        },
      }
    });
    const headerFont = { name: 'Calibri', family: 2, size: 11, bold: true };
    const dataFont = { name: 'Calibri', family: 2, size: 11 };
    let error = false;
    let errorMessage = "";
    // Set width and height of columns and rows [width pixel / 6.9]
    worksheet.columns = [{ width: 9.71 },{ width: 6.96 },{ width: 30.72 },{ width: 6.96 },{ width: 28.74 },{ width: 9.71 }];
    // Header
    worksheet.getCell('D2').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'757070' } };
    worksheet.getCell('D2').border = { top: { style:'medium' }, left: { style:'medium' }, bottom: { style:'medium' }, right: { style:'thin' } };
    worksheet.getCell('D2').font = headerFont;
    worksheet.getCell('D2').alignment = { horizontal: 'left' };
    worksheet.getCell('D2').value = "No.";
    worksheet.getCell('E2').border = { top: { style:'medium' }, left: { style:'thin' }, bottom: { style:'medium' }, right: { style:'medium' } };
    worksheet.getCell('D3').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'757070' } };
    worksheet.getCell('D3').border = { top: { style:'medium' }, left: { style:'medium' }, bottom: { style:'medium' }, right: { style:'thin' } };
    worksheet.getCell('D3').font = headerFont;
    worksheet.getCell('D3').alignment = { horizontal: 'left' };
    worksheet.getCell('D3').value = "Name";
    worksheet.getCell('E3').border = { top: { style:'medium' }, left: { style:'thin' }, bottom: { style:'medium' }, right: { style:'medium' } };
    // Header images
    worksheet.getRow(4).height = 30;
    worksheet.addImage(workbook.addImage({base64: IconImage, extension: 'png'}), { tl: { col: 2, row: 0 }, ext: { width: 175, height: 95 } });
    // Seal Decklist Header
    worksheet.getCell('B5').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('B5').border = { top: { style:'medium' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
    worksheet.getCell('B5').font = headerFont;
    worksheet.getCell('B5').alignment = { horizontal: 'center' };
    worksheet.getCell('B5').value = "In Deck";
    worksheet.mergeCells('C5:E5');
    worksheet.getCell('C5').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('C5').border = { top: { style:'medium' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
    worksheet.getCell('C5').font = headerFont;
    worksheet.getCell('C5').alignment = { horizontal: 'center' };
    worksheet.getCell('C5').value = "Seal Card";
    // Seal Decklist
    const seals = props.deck.filter(c => c.type === 'seal');
    if (seals.length > 19){
      error = true;
      errorMessage = "จำนวนการ์ด Seal มากกว่าจำนวนช่องของใบ Decklist จึงไม่สามารถปริ้นได้";
    }
    else {
      for (let i = 0; i < 19; i++){
        let row = i+6;
        // Amount
        worksheet.getCell('B'+row).border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
        worksheet.getCell('B'+row).font = dataFont;
        worksheet.getCell('B'+row).alignment = { horizontal: 'center' };
        if (i < seals.length){
          worksheet.getCell('B'+row).value = seals[i].qty;
        }
        // Seal Card
        worksheet.mergeCells('C'+row+':E'+row);
        worksheet.getCell('C'+row).border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
        worksheet.getCell('C'+row).font = dataFont;
        worksheet.getCell('C'+row).alignment = { horizontal: 'center' };
        if (i < seals.length){
          worksheet.getCell('C'+row).value = seals[i].name;
        }
      }
    }
    // Seal Decklist Footer
    worksheet.getCell('B25').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'f2f2f2' } };
    worksheet.getCell('B25').border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'medium' }, right: { style:'thin' } };
    worksheet.getCell('B25').font = dataFont;
    worksheet.getCell('B25').alignment = { horizontal: 'center' };
    worksheet.getCell('B25').value = seals.reduce((acc, {qty}) => acc + qty, 0);
    worksheet.mergeCells('C25:E25');
    worksheet.getCell('C25').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('C25').border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'medium' }, right: { style:'medium' } };
    worksheet.getCell('C25').font = headerFont;
    worksheet.getCell('C25').alignment = { horizontal: 'center' };
    worksheet.getCell('C25').value = "<<<Total Seal Card";
    // Empty row for spacing
    worksheet.getRow(26).height = 5;
    // Mystic Decklist Header
    worksheet.getCell('B27').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('B27').border = { top: { style:'medium' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
    worksheet.getCell('B27').font = headerFont;
    worksheet.getCell('B27').alignment = { horizontal: 'center' };
    worksheet.getCell('B27').value = "In Deck";
    worksheet.mergeCells('C27:E27');
    worksheet.getCell('C27').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('C27').border = { top: { style:'medium' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
    worksheet.getCell('C27').font = headerFont;
    worksheet.getCell('C27').alignment = { horizontal: 'center' };
    worksheet.getCell('C27').value = "Mystic Card";
    // Mystic Decklist
    const mystics = props.deck.filter(c => c.type === 'mystic');
    if (mystics.length > 19){
      error = true;
      errorMessage = "จำนวนการ์ด Mystic มากกว่าจำนวนช่องของใบ Decklist จึงไม่สามารถปริ้นได้";
    }
    else {
      for (let i = 0; i < 19; i++){
        let row = i+28;
        // Amount
        worksheet.getCell('B'+row).border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
        worksheet.getCell('B'+row).font = dataFont;
        worksheet.getCell('B'+row).alignment = { horizontal: 'center' };
        if (i < mystics.length){
          worksheet.getCell('B'+row).value = mystics[i].qty;
        }
        // Mystic Card
        worksheet.mergeCells('C'+row+':E'+row);
        worksheet.getCell('C'+row).border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
        worksheet.getCell('C'+row).font = dataFont;
        worksheet.getCell('C'+row).alignment = { horizontal: 'center' };
        if (i < mystics.length){
          worksheet.getCell('C'+row).value = mystics[i].name;
        }
      }
    }
    // Mystic Decklist Footer
    worksheet.getCell('B47').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'f2f2f2' } };
    worksheet.getCell('B47').border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'medium' }, right: { style:'thin' } };
    worksheet.getCell('B47').font = dataFont;
    worksheet.getCell('B47').alignment = { horizontal: 'center' };
    worksheet.getCell('B47').value = mystics.reduce((acc, {qty}) => acc + qty, 0);
    worksheet.mergeCells('C47:E47');
    worksheet.getCell('C47').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('C47').border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'medium' }, right: { style:'medium' } };
    worksheet.getCell('C47').font = headerFont;
    worksheet.getCell('C47').alignment = { horizontal: 'center' };
    worksheet.getCell('C47').value = "<<<Total Mystic Card";
    // Empty row for spacing
    worksheet.getRow(48).height = 5;
    // Master Heart Decklist Header
    worksheet.getCell('B49').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('B49').border = { top: { style:'medium' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
    worksheet.getCell('B49').font = headerFont;
    worksheet.getCell('B49').alignment = { horizontal: 'center' };
    worksheet.getCell('B49').value = "In Deck";
    worksheet.mergeCells('C49:E49');
    worksheet.getCell('C49').fill = { type: 'pattern', pattern:'solid', fgColor:{ argb:'d8d8d8' } };
    worksheet.getCell('C49').border = { top: { style:'medium' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
    worksheet.getCell('C49').font = headerFont;
    worksheet.getCell('C49').alignment = { horizontal: 'center' };
    worksheet.getCell('C49').value = "Master Heart";
    // Master Heart Decklist
    const hearts = props.deck.filter(c => c.type === 'heart');
    if (hearts.length > 3){
      error = true;
      errorMessage = "จำนวนการ์ด Master Heart มากกว่าจำนวนช่องของใบ Decklist จึงไม่สามารถปริ้นได้";
    }
    else {
      for (let i = 0; i < 3; i++){
        let row = i+50;
        // Amount
        worksheet.getCell('B'+row).border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'thin' }, right: { style:'thin' } };
        if (i === 2) worksheet.getCell('B'+row).border = { top: { style:'none' }, left: { style:'medium' }, bottom: { style:'medium' }, right: { style:'thin' } };
        worksheet.getCell('B'+row).font = dataFont;
        worksheet.getCell('B'+row).alignment = { horizontal: 'center' };
        if (i < hearts.length){
          worksheet.getCell('B'+row).value = hearts[i].qty;
        }
        // Master Heart Card
        worksheet.mergeCells('C'+row+':E'+row);
        worksheet.getCell('C'+row).border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'thin' }, right: { style:'medium' } };
        if (i === 2) worksheet.getCell('C'+row).border = { top: { style:'none' }, left: { style:'thin' }, bottom: { style:'medium' }, right: { style:'medium' } };
        worksheet.getCell('C'+row).font = dataFont;
        worksheet.getCell('C'+row).alignment = { horizontal: 'center' };
        if (i < hearts.length){
          worksheet.getCell('C'+row).value = hearts[i].name;
        }
      }
    }
    // Let the client download the file
    if (!error){
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'Decklist.xlsx';
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    }
    else {
      alert(errorMessage);
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          ยืนยันการปริ้น Decklist
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ทางเว็บ SMNDB ไม่การันตีความถูกต้องของข้อมูลการ์ดที่ปริ้น Decklist นี้
        </p>
        <p>
          เมื่อปริ้นไปแล้ว <b>โปรดตรวจสอบความถูกต้องของข้อมูลการ์ดด้วยตนเองอีกครั้ง</b> ก่อนนำส่งต่อเจ้าหน้าที่เมื่อเข้าแข่งขันทุกครั้ง
        </p>
        <p>
          ไฟล์ Decklist นี้เป็นการทำเลียนแบบต้นฉบับเท่านั้น มีโอกาสที่จะใช้ไม่ได้หากแบบฟอร์ม Decklist ในงานนั้นๆมีการเปลี่ยนแปลง
        </p>
        <p>
          <i>*หากมี Seal ไม่ซ้ำกันเกิน 19 ใบ หรือ Mystic ไม่ซ้ำกันเกิน 19 ใบ จะไม่สามารถปริ้นได้ เพราะช่องของ Decklist ไม่พอ</i>
        </p>
        <p>
          <i>**Feature นี้อยู่ในขั้นตอนการทดสอบ (ปัญหาหลักตอนนี้ ios ส่วนใหญ่ปริ้นไม่ออก)</i>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          onClick={() => exportToExcel()} 
          disabled={props.deck.filter(c => c.type === 'seal').length > 20 || props.deck.filter(c => c.type === 'mystic').length > 20}
        >เข้าใจและยืนยันการปริ้น Decklist</Button>
      </Modal.Footer>
    </Modal>
  );
}